import { FC, useRef } from 'react'
import { HexColorPicker } from 'react-colorful'
import { Box, ClickAwayListener, Popper, SxProps } from '@mui/material'

import { useOnClickOutside } from '@hooks'

type ColorPickerProps = {
  open: boolean
  color?: string
  onChange: (value: string) => void
  onClickOutside: () => void
  sx?: SxProps
  anchorEl?: HTMLElement | null
}

export const ColorPicker: FC<ColorPickerProps> = ({
  open,
  color,
  sx,
  onChange,
  onClickOutside,
  anchorEl,
}) => {
  const popover = useRef<HTMLDivElement>(null)

  useOnClickOutside(popover, onClickOutside)

  if (!open) {
    return null
  }

  if (anchorEl) {
    return (
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement='bottom-start'
        popperOptions={{strategy: 'fixed'}}
        sx={{ zIndex: theme => theme.zIndex.modal + 2, ...sx }}
        modifiers={[
          { name: 'offset', options: { offset: [0, 8] } },
          { name: 'preventOverflow', options: { padding: 8 } },
          { name: 'flip', options: { fallbackPlacements: ['top-start', 'bottom-end', 'top-end'] } },
        ]}
      >
        <ClickAwayListener onClickAway={onClickOutside}>
          <Box ref={popover} className='popover'>
            <HexColorPicker color={color} onChange={onChange} />
          </Box>
        </ClickAwayListener>
      </Popper>
    )
  }

  return (
    <Box
      ref={popover}
      className='popover'
      position='absolute'
      right='-214px'
      sx={sx}
      top='-202px'
      zIndex={theme => theme.zIndex.tooltip}
    >
      <HexColorPicker color={color} onChange={onChange} />
    </Box>
  )
}
